import React, { useState, useEffect } from 'react';
import api from '../services/api';
import PortalLayout, { card, StateMsg, datumNL, datumTijdNL } from '../components/PortalLayout';
const STATUS_KLEUR = {
  nieuw: { bg: '#eff6ff', fg: '#1d4ed8' },
  in_behandeling: { bg: '#fff7ed', fg: '#c2410c' },
  afgehandeld: { bg: '#ecfdf5', fg: '#047857' },
  opgelost: { bg: '#ecfdf5', fg: '#047857' },
  werkorder_aangemaakt: { bg: '#f5f3ff', fg: '#6d28d9' },
  doorgestuurd: { bg: '#f5f3ff', fg: '#6d28d9' },
  afgewezen: { bg: '#f1f5f9', fg: '#64748b' },
};
const BRON_LABEL = { melding: 'Melding', storing: 'Storing' };
export default function Storingen() {
  const [items, setItems] = useState(null);
  const [error, setError] = useState(null);
  const [zoek, setZoek] = useState('');
  const [openId, setOpenId] = useState(null);
  useEffect(() => {
    api.get('/klantportaal/storingen')
      .then((r) => setItems(r.data.storingen || []))
      .catch(() => setError('Kon storingen niet laden'));
  }, []);
  const q = zoek.trim().toLowerCase();
  const zichtbaar = (items || []).filter((s) => {
    if (!q) return true;
    return [s.titel, s.object_naam, s.status, BRON_LABEL[s.bron] || s.bron, s.ordernummer].filter(Boolean).join(' ').toLowerCase().includes(q);
  });
  return (
    <PortalLayout titel="Mijn storingen">
      {items && items.length > 0 && (
        <input
          value={zoek}
          onChange={(e) => setZoek(e.target.value)}
          placeholder={'Zoek op titel, object of status\u2026'}
          style={{ width: '100%', boxSizing: 'border-box', padding: '11px 14px', border: '1px solid #e2e8f0', borderRadius: 10, fontSize: 14, marginBottom: 14, background: '#fff', color: '#1e293b' }}
        />
      )}
      <StateMsg loading={!items && !error} error={error} leeg={items && items.length === 0} leegTekst="Nog geen storingen of meldingen." />
      {items && items.length > 0 && zichtbaar.length === 0 && (
        <div style={{ color: '#94a3b8', fontSize: 13, textAlign: 'center', marginTop: 20 }}>Geen resultaten.</div>
      )}
      {zichtbaar.map((s) => {
        const st = STATUS_KLEUR[s.status] || { bg: '#f1f5f9', fg: '#64748b' };
        const key = s.bron + '-' + s.id;
        const open = openId === key;
        return (
          <div key={key} style={{ ...card, cursor: 'pointer' }} onClick={() => setOpenId(open ? null : key)}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
              <div style={{ fontWeight: 600, color: '#1e293b' }}>{s.titel || 'Storing'}</div>
              {s.status && <span style={{ background: st.bg, color: st.fg, fontSize: 11, fontWeight: 700, padding: '3px 8px', borderRadius: 6, whiteSpace: 'nowrap' }}>{s.status}</span>}
            </div>
            {s.object_naam && <div style={{ color: '#00D4AA', fontSize: 13, fontWeight: 600, marginTop: 4 }}>{s.object_naam}</div>}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 6 }}>
              <span style={{ background: '#f1f5f9', color: '#475569', fontSize: 11, fontWeight: 600, padding: '2px 7px', borderRadius: 5 }}>{BRON_LABEL[s.bron] || s.bron}{s.ordernummer ? ' \u00b7 WO ' + s.ordernummer : ''}</span>
              <span style={{ color: '#94a3b8', fontSize: 12 }}>{datumNL(s.created_at)}</span>
            </div>
            {open && (
              <div style={{ marginTop: 12, borderTop: '1px solid #f1f5f9', paddingTop: 12 }}>
                {s.beschrijving && <div style={{ fontSize: 14, color: '#334155', whiteSpace: 'pre-wrap', marginBottom: 8 }}>{s.beschrijving}</div>}
                {s.locatie_adres && <div style={{ fontSize: 13, color: '#64748b', marginBottom: 4 }}>📍 {s.locatie_adres}</div>}
                {s.prioriteit && <div style={{ fontSize: 13, color: '#64748b' }}>Prioriteit: {s.prioriteit}</div>}
                {(s.tijdlijn_json || []).length > 0 && (
                  <div style={{ marginTop: 10 }}>
                    <div style={{ fontSize: 12.5, fontWeight: 700, color: '#1e293b', marginBottom: 6 }}>Tijdlijn</div>
                    {s.tijdlijn_json.map((t, i) => (
                      <div key={i} style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 4 }}>
                        <span style={{ width: 8, height: 8, borderRadius: 4, background: '#00D4AA', flexShrink: 0, position: 'relative', top: 0 }} />
                        <span style={{ fontSize: 13, color: '#334155', fontWeight: 600, textTransform: 'capitalize' }}>{String(t.status).replace(/_/g, ' ')}</span>
                        <span style={{ fontSize: 12, color: '#94a3b8', marginLeft: 'auto', whiteSpace: 'nowrap' }}>{datumTijdNL(t.created_at)}</span>
                      </div>
                    ))}
                  </div>
                )}
                {(s.afhandeling_json || []).length > 0 && (
                  <div style={{ marginTop: 10 }}>
                    <div style={{ fontSize: 12.5, fontWeight: 700, color: '#1e293b', marginBottom: 6 }}>Afhandeling</div>
                    <div style={{ background: '#f8fafc', borderRadius: 8, padding: '8px 10px' }}>
                      {s.afhandeling_json.map((a, i) => (
                        <div key={i} style={{ display: 'flex', gap: 8, fontSize: 13, marginBottom: 3 }}>
                          <span style={{ color: '#64748b', minWidth: 110 }}>{a.label}:</span>
                          <span style={{ color: '#334155', fontWeight: 600 }}>{a.waarde || '—'}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
                {(s.logs_json || []).length > 0 && (
                  <div style={{ marginTop: 10 }}>
                    <div style={{ fontSize: 12.5, fontWeight: 700, color: '#1e293b', marginBottom: 6 }}>Uitgevoerd werk</div>
                    {s.logs_json.map((lg, i) => (
                      <div key={i} style={{ background: '#f8fafc', borderRadius: 8, padding: '8px 10px', marginBottom: 6 }}>
                        <div style={{ fontSize: 13, color: '#334155', whiteSpace: 'pre-wrap' }}>{String(lg.beschrijving || '').split(/\n(?=Objectdelen:)/)[0].trim()}</div>
                        <div style={{ fontSize: 11.5, color: '#94a3b8', marginTop: 4 }}>{lg.naam || ''} · {datumTijdNL(lg.created_at)}</div>
                      </div>
                    ))}
                  </div>
                )}
                {!s.beschrijving && !s.locatie_adres && !s.prioriteit && !(s.logs_json || []).length && <div style={{ fontSize: 13, color: '#94a3b8' }}>Geen verdere details.</div>}
              </div>
            )}
          </div>
        );
      })}
    </PortalLayout>
  );
}
